var RichText={ResizeableCombo:{SizeSwitcher:{"default":{content:"Expand",accessibilityLabel:"Switch to the expanded Rich Text Editor"},expanded:{content:"Fullscreen",accessibilityLabel:"Switch to the fullscreen Rich Text Editor"},fullscreen:{content:"Minimize",accessibilityLabel:"Switch to the minimized Rich Text Editor"}}}};var _en = {RichText:RichText};

export { RichText, _en as default };
